export default __webpack_public_path__ + "images/ff70761710629a12192cc1adc48a1fef.svg";